interface Props {
  className?: string;
  description: string;
}

export default function TableDataColumn2(props: Props) {
  const { className, description } = props;

  const getClassNames = () => {
    const defaultClasses = "bg-promWhite";

    if (className) {
      return `${defaultClasses} ${className}`;
    }

    return defaultClasses;
  };

  return(
    <td className={getClassNames()}>
      {description}
    </td>
  );
}